<div class="auth-layout-wrap">
    <!-- style="background-image: url(./assets/images/photo-wide-4.jpg)" -->
    <div class="auth-content">
        <router-outlet></router-outlet>
    </div>
</div>